import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/microsoft-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-3b563e6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "auth-block" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "auth-block__logo",
  src: _imports_0,
  alt: "Microsoft logotype"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "auth-block__text" }, " Войти с помощью учетной записи Майкрософт ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { class: "svg" }, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clipping" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M469 25C482.807 25 494 13.8071 494 0H528C536.837 0 544 7.16345 544 16V348C544 356.837 536.837 364 528 364H16C7.16345 364 0 356.837 0 348V16C0 7.16345 7.16345 0 16 0H444C444 13.8071 455.193 25 469 25Z" })
  ])
], -1))

import { msalInstance } from "@/app.config";
import { onMounted } from "vue";
import { useAuthStore } from "@/store/AuthModule";
import CommonApi from "@/api/CommonApi";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginComponent',
  setup(__props) {

const authStore = useAuthStore();
const api = new CommonApi();

const loginRequest = {
  scopes: ["api://SOBI/read"],
  prompt: "select_account",
};

async function signIn() {
  await msalInstance
    .handleRedirectPromise()
    .then((response: any) => {
      if (response !== null) {
        setAuthData(response.accessToken, response.account.name);
      } else {
        const acc = msalInstance.getAllAccounts();

        if (acc.length === 0) {
          msalInstance
            .loginPopup(loginRequest)
            .then((res) => {
              setAuthData(res.accessToken, res.account?.name);
            })
            .then(() => {
              api
                .checkRoles()
                .then((res) => {
                  authStore.setRoles(res);
                })
                .then(() => {
                  if (authStore.roles.admin) {
                    router.push({ name: "admin" });
                  } else if (authStore.roles.user) {
                    router.push({ name: "user" });
                  }
                });
            });
        }
      }
    })
    .catch((error: Error) => {
      console.log(error);
    });
}

async function setAuthData(token: string, name: string | null | undefined) {
  authStore.setToken(token);
  authStore.setName(name);
}

async function getAccessToken() {
  try {
    const tokenResponse = await msalInstance.acquireTokenSilent(loginRequest);
    await setAuthData(tokenResponse.accessToken, tokenResponse.account?.name);
    api
      .checkRoles()
      .then((res) => {
        authStore.setRoles(res);
      })
      .then(() => {
        if (authStore.roles.admin) {
          router.push({ name: "admin" });
        } else if (authStore.roles.user) {
          router.push({ name: "user" });
        }
      });
  } catch {
    const tokenResponse = await msalInstance.acquireTokenPopup(loginRequest);
    await setAuthData(tokenResponse.accessToken, tokenResponse.account?.name);
    api
      .checkRoles()
      .then((res) => {
        authStore.setRoles(res);
      })
      .then(() => {
        if (authStore.roles.admin) {
          router.push({ name: "admin" });
        } else if (authStore.roles.user) {
          router.push({ name: "user" });
        }
      });
  }
}

onMounted(async () => {
  const accounts = await msalInstance.getAllAccounts();
  if (accounts.length !== 0) {
    msalInstance.setActiveAccount(accounts[0]);
    await getAccessToken();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("button", {
        class: "auth-block__login-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (signIn()))
      }, "Войти")
    ]),
    _hoisted_5
  ]))
}
}

})